///**
//* @ngdoc directive
//* @module components.tiles
//* @name components.tiles:genericTile
//* @scope
//* @restrict E
//* @description
//* Tile that animates in displays a chunk of text and reveals more when it is hovered over. The position of the expanding region can be changed by adding the class "bottom" or "top." Content that is visible initially should go inside the "above-fold" tag, while content that appears on hover should go in the "below-fold" tag.
//* @param {string=} backgroundImage Places an image behind the tile.
//* @example
//<example module="dataExample">
//    <file name="index.html">
//        <div ng-controller="exampleController">
//            <h3>Tile has no class</h3>
//            <generic-tile background-image="//lorempixel.com/400/400/animals">
//                <above-fold>
//                    <h5 style="color: red">No Class Test</h3>
//                </above-fold>
//                <below-fold>
//                    <p>If no class is set, the content will be vertically centered before hover.</p>
//                </below-fold>
//            </generic-tile>
//            <h3>Tile has class "bottom"</h3>
//            <generic-tile class="bottom" background-image="//lorempixel.com/400/400/animals">
//                <above-fold>
//                    <h5 style="color: red">No Class Test</h3>
//                </above-fold>
//                <below-fold>
//                    <p>If no class is set, the content will be vertically centered before hover.</p>
//                </below-fold>
//            </generic-tile>
//            <h3>Tile has class "top"</h3>
//            <generic-tile class="top" background-image="//lorempixel.com/400/400/animals">
//                <above-fold>
//                    <h5 style="color: red">No Class Test</h3>
//                </above-fold>
//                <below-fold>
//                    <p>If no class is set, the content will be vertically centered before hover.</p>
//                </below-fold>
//            </generic-tile>
//        </div>
//    </file>
//    <file name="script.js">
//        (function() {
//            angular.module('dataExample', ['components.tiles'])
//                .controller('exampleController', exampleController);

//            exampleController.$inject = ['$scope'];
//            function exampleController($scope) {
//                $scope.tileData = {
//                    url: '#',
//                    image: {
//                        caption: 'Test Image',
//                        url: '//lorempixel.com/400/400/Test Image',
//                        height: 400,
//                        width: 400,
//                        crops: [
//                            {
//                                name: 'tile',
//                                height: 400,
//                                width: 400,
//                                url: '//lorempixel.com/400/400/Test Image'
//                            }
//                        ]
//                    },
//                    name: 'Example Tile',
//                    summary: '<p>This is an example tile. You can put a variety of content in here.</p>'
//                };
//            }
//        })();
//    </file>
//</example>
//*/
//(function () {
//    angular.module('app')
//        .component('genericTileV2', {
//            bindings: {
//                alignment: '@?',
//                position: '@?',
//                backgroundImage: '@?'
//            },
//            transclude: {
//                'aboveFold': 'aboveFold',
//                'belowFold': 'belowFold'
//            },
//            templateUrl: '/angular/components/tiles/genericTileV2.html',
//            controller: genericTileController
//        });

//    genericTileController.$inject = ['$scope', '$element', '$window', 'helper', '$transclude'];
//    function genericTileController($scope, $element, $window, helper, $transclude) {
//        var ctrl = this;

//        ctrl.$onInit = function () {
//            switch (ctrl.alignment) {
//                case 'top': case 'center':
//                    break;
//                default:
//                    ctrl.alignment = 'bottom';
//                    break;
//            }
//            $element.addClass(ctrl.alignment);
//            switch (ctrl.position) {
//                case 'bottom': case 'center':
//                    break;
//                default:
//                    ctrl.position = 'top';
//                    break;
//            }
//            if (!ctrl.backgroundImage) {
//                ctrl.backgroundReady = true;
//            }
//            ctrl.aboveHeight = 0;
//            ctrl.$contentContainer = $element.find('.vc');
//            $transclude(function (clone) {
//                ctrl.$contentContainer.append(clone);
//            }, null, 'aboveFold');
//            $transclude(function (clone) {
//                ctrl.$contentContainer.append(clone);
//            }, null, 'belowFold');
//        };

//        ctrl.$postLink = function () {
//            ctrl.$above = $element.find('above-fold');
//            ctrl.$below = $element.find('below-fold');
//            ctrl.$sizeTitle();
//            angular.element($window).on('resize.genericTile', ctrl.$sizeTitle);
//            $element.on('mouseenter.genericTile', function () {
//                $scope.$evalAsync(function () {
//                    ctrl.offset = Math.max(0, ($element.height() - ctrl.$contentContainer.height() - 30) / 2);
//                });
//            }).on('mouseleave.genericTile', function () {
//                $scope.$evalAsync(function () {
//                    ctrl.offset = 0;
//                });
//            });
//        };

//        ctrl.$onDestroy = function () {
//            $element.off('mouseenter.genericTile').off('mouseleave.genericTile');
//            angular.element($window).off('resize.genericTile');
//        };

//        ctrl.$sizeTitle = function () {
//            var height = ctrl.$above.height();
//            if (ctrl.$aboveHeight !== height) {
//                $scope.$evalAsync(function () {
//                    ctrl.$aboveHeight = height;
//                    ctrl.flexStyle = {
//                        flex: '0 1 ' + ((height + 30) / $element.height() * 100) + '%'
//                    };
//                });
//            }
//        };

//        ctrl.onBackgroundLoad = function () {
//            ctrl.backgroundReady = true;
//        };
//    }
//})();